import type { XingletInterface } from './xinglet-helpers';
import { XingletWrapper } from './xinglet-helpers';

export type CoverLetterAiFormProps = {
  onSectionVisibilityChange: (
    section: string,
    intersectionRatio: number
  ) => void;
};

export type CoverLetterAiFormXinglet = XingletInterface<CoverLetterAiFormProps>;

export const CoverLetterAIForm = XingletWrapper<CoverLetterAiFormProps>(
  '@xing-com/crate-lebenslauf-components-cover-letter-ai-form'
);
